// extracted by mini-css-extract-plugin
export var animationAbsolute = "_3s-q";
export var animationRelative = "_3s-p";
export var backdropBlur = "_3s-0";
export var detailLabelCell = "_3s-12";
export var detailTable = "_3s-11";
export var detailValueCell = "_3s-13";
export var docIconBox = "_3s-1d";
export var docIconBoxMd = "_3s-1f";
export var docIconBoxSm = "_3s-1e";
export var docTypeRow = "_3s-16";
export var docTypeRowInner = "_3s-17";
export var dropdownMatchDatePicker = "_3s-3";
export var evidenceCardContent = "_3s-1c";
export var fileUploadSpin = "_3s-j";
export var gorgiasOpenButton = "_3s-15 _3s-d";
export var gorgiasTicketCard = "_3s-14";
export var heroModalFooterButton = "_3s-18";
export var hiddenContainer = "_3s-o";
export var iconPrimary = "_3s-1g";
export var iconQuaternary = "_3s-1i";
export var iconTertiary = "_3s-1h";
export var integrationCard = "_3s-1";
export var integrationLogoBox = "_3s-2";
export var mainColumnSticky = "_3s-1b";
export var maxWidthContainer = "_3s-19";
export var modalContentBody = "_3s-a";
export var modalHeaderImage = "_3s-5";
export var modalImageLabel = "_3s-7";
export var modalImageOverlay = "_3s-6";
export var modalImageSubtitle = "_3s-9";
export var modalImageTitle = "_3s-8";
export var modalImageWrapper = "_3s-4";
export var modalStickyFooter = "_3s-b";
export var removeButton = "_3s-e";
export var sidebarColumn = "_3s-1a";
export var spinner = "_3s-i";
export var timelineLine = "_3s-y";
export var timelineLineBlack = "_3s-10 _3s-y";
export var timelineLineGray = "_3s-z _3s-y";
export var timelineLineHeight = "_3s-x";
export var tlDotActivate = "_3s-u";
export var tlDotActivateAnim = "_3s-t";
export var tlDotHide = "_3s-s";
export var tlDotHideAnim = "_3s-r";
export var tlLineActivate = "_3s-w";
export var tlLineActivateAnim = "_3s-v";
export var uploadHint = "_3s-n";
export var uploadIconBox = "_3s-k";
export var uploadLabel = "_3s-m";
export var uploadText = "_3s-l";
export var uploadZone = "_3s-f";
export var uploadZoneCursorDefault = "_3s-h";
export var uploadZoneCursorPointer = "_3s-g";
export var uploadedFileRow = "_3s-c";
export var viewButton = "_3s-d";